import styled from 'styled-components';

import { SmallSubtitle } from '../../../foundations/typefaces/SmallSubtitle';
import type { Color as ThemeColor, Size as ThemeSize } from '../../../style/types/theme';
import { Size, Variant } from './types';

interface TextLabelContainerProps {
  $size: Size;
  $variant: Variant;
}

const getHeight = (size: Size, themeSize: ThemeSize) => {
  switch (size) {
    case Size.BIG:
      return themeSize.units(2.5);
    case Size.SMALL:
    default:
      return themeSize.units(2);
  }
};

const getBorderRadius = (size: Size, themeSize: ThemeSize) => {
  switch (size) {
    case Size.BIG:
      return themeSize.units(0.5);
    case Size.SMALL:
    default:
      return themeSize.units(0.25);
  }
};

const getPadding = (size: Size, themeSize: ThemeSize) => {
  switch (size) {
    case Size.BIG:
      return themeSize.units(1);
    case Size.SMALL:
    default:
      return themeSize.units(0.5);
  }
};

const getBackgroundColor = (variant: Variant, color: ThemeColor) => {
  switch (variant) {
    case Variant.DARK:
      return color.background.reversed.default();
    case Variant.TERTIARY:
      return color.background.complementary(11);
    default:
      return color.background.quaternary.default();
  }
};

const getTextColor = (variant: Variant, color: ThemeColor) => {
  switch (variant) {
    case Variant.DARK:
    case Variant.TERTIARY:
      return color.content.reversed.default();
    default:
      return color.content.secondary.default();
  }
};

export const TextLabelContainer = styled.div<TextLabelContainerProps>(
  ({ theme: { color, size }, $size, $variant }) => ({
    width: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: getHeight($size, size),
    borderRadius: getBorderRadius($size, size),
    padding: `0 ${getPadding($size, size)}`,
    backgroundColor: getBackgroundColor($variant, color),
    pointerEvents: 'none',

    [SmallSubtitle]: {
      color: getTextColor($variant, color),
    },
  }),
);
